import { useCallback, useEffect, useRef } from "react";

export const BudgetPersistance = (draftId, watch, isDirty, isLoadingRef) => {

    const timeoutRef = useRef(null);

    useEffect(() => {
        const subscription = watch((value) => {
            //Skip the save while a draft is being loaded into the form, otherwise the
            //incoming draft's values would be written under the previous draft's id
            if (isLoadingRef?.current) return;

            //If the user hasn't modified a budget, we won't save it as a draft
            if (!isDirty || (!value.title && !value.customerSearch)) return;

            //The callback's return value is ignored by react-hook-form, so the timer is
            //kept in a ref and cleared here to actually debounce consecutive changes
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                const dataToSave = {...value, _lastModified: new Date().toISOString()};
                localStorage.setItem(draftId, JSON.stringify(dataToSave));
                // console.log("Updated budget's draft")
            }, 2000);   //Set a 2 second debounce before saving the budget
        });

        //Cancel any write still pending for the previous draft before switching
        return () => {
            clearTimeout(timeoutRef.current);
            subscription.unsubscribe();
        };
    }, [watch, draftId, isDirty, isLoadingRef])

    //Callers always pass the id, so this closes over nothing and keeps a stable identity
    const getDraft = useCallback((id) => {
        const localDraft = localStorage.getItem(id);

        if (!localDraft) return null;

        const parsed = JSON.parse(localDraft);

        //This will help to "restore" the dates format
        ['startDate', 'dueDate', 'lastShip'].forEach(f => {
            if (parsed[f]) parsed[f] = new Date(parsed[f]);
        });

        return parsed;
    }, [])

    const clearDraft = useCallback((id) => {
        const removeId = id || draftId;
        localStorage.removeItem(removeId);
    }, [draftId])

    return {getDraft, clearDraft};
}